import type { KeycloakConfig, KeycloakInitOptions, KeycloakLoginOptions, KeycloakLogoutOptions } from 'keycloak-js';

import { createKeycloak, refreshToken, token } from '@abaninja/util-keycloak';

const keycloakConfig: KeycloakConfig = {
  clientId: import.meta.env.VITE_S21_IDP_CLIENT_ID,
  realm: import.meta.env.VITE_S21_IDP_REALM,
  url: import.meta.env.VITE_S21_IDP_URL,
};

const keycloakInitOptions: KeycloakInitOptions = {
  checkLoginIframe: false,
  enableLogging: true,
  refreshToken: refreshToken.get(),
  responseMode: 'fragment',
  scope: import.meta.env.VITE_S21_IDP_SCOPE.replaceAll(',', ' '),
  timeSkew: 0,
  token: token.get(),
};

const redirectUri = `${import.meta.env.VITE_BASE_URL as string}/oauthcb`;

const keycloakLoginOptions: KeycloakLoginOptions = {
  redirectUri,
  scope: import.meta.env.VITE_S21_IDP_SCOPE.replaceAll(',', ' '),
};

const keycloakLogoutOptions: KeycloakLogoutOptions = {
  redirectUri: import.meta.env.VITE_S21_IDP_LOGOUT_REDIRECT_URI,
};

export const initKeycloak = createKeycloak(keycloakConfig, keycloakInitOptions, keycloakLoginOptions, keycloakLogoutOptions);
